'use client';

import {
  selectBundleVariants,
  selectCurrentProductStockState,
  selectLeadtimeShippingFee,
  selectVariant,
} from '@castlery/modules-product-domain';
import { useAppSelector } from '@castlery/shared-redux-store';
import { useMemo, useState } from 'react';
import { STOCK_STATE } from '@castlery/utils';
import { Link, Stack, Typography } from '@castlery/fortress';
import { ArrowForwardIos } from '@castlery/fortress/Icons';
import { enableWebHasShowroom } from '@castlery/config';
import { ProductStockShowroomDrawer } from './product-stock-showroom-drawer';

export const ProductStockShowroom = () => {
  const [openShowroomDrawer, setOpenShowroomDrawer] = useState(false);
  const variant = useAppSelector(selectVariant);
  const leadTimeShippingFee = useAppSelector(selectLeadtimeShippingFee);
  const stockState = useAppSelector(selectCurrentProductStockState);
  const retailIds = leadTimeShippingFee?.retail_ids;
  const bundleVariants = useAppSelector(selectBundleVariants);
  const uid = useMemo(() => {
    return variant?.sketchfab_3d_model_id?.trim();
  }, [variant]);
  return (
    <>
      {retailIds && retailIds?.length ? (
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          sx={{
            mt: 2,
          }}
        >
          <Typography
            level="body2"
            sx={{
              color: 'var(--fortress-palette-neutral-plainColor)',
            }}
          >
            See it in our showroom.
          </Typography>
          <Link
            variant="primary"
            component="button"
            endDecorator={
              <ArrowForwardIos
                sx={{
                  width: '20px',
                  height: '20px',
                }}
              />
            }
            level="caption1"
            onClick={() => {
              setOpenShowroomDrawer(true);
            }}
          >
            Find Showroom
          </Link>
        </Stack>
      ) : enableWebHasShowroom ? (
        <Typography
          level="body2"
          sx={{
            mt: 2,
            color: 'var(--fortress-palette-neutral-plainColor)',
          }}
        >
          {stockState === STOCK_STATE.OUT_OF_STOCK ? 'Currently unavailable.' : "This item isn't on display right now."}
        </Typography>
      ) : null}
      <ProductStockShowroomDrawer
        open={openShowroomDrawer}
        onClose={() => setOpenShowroomDrawer(false)}
        retailIds={retailIds}
        variant={variant}
        bundleVariants={bundleVariants}
      />
    </>
  );
};
